// Dependencias generales
import React from "react";
import { useEffect, useState } from 'react';
import '../../css/common.css';
import '../../css/initialConfigStyle.css';
import GeneralInfo from './InitialConfig/GeneralInfo';
import Messaging from './InitialConfig/Messaging';
import Loader from '../../components/Utils/Loader'
import ReactGA from "react-ga4";

const endpointHelias = "https://9m4y8iz04h.execute-api.eu-west-3.amazonaws.com/prod"
const getInstallationConfiguration = endpointHelias+"/Helias/V0/Configuration/getInstallationConfiguration"

var initialConfigCommonJS = require("../../js/initialConfigCommon.js")
var generalCommonJS = require("../../js/generalCommon.js")

// Initial config - Welcome
const InstallationConfigurationOptions = (params) => {
  
  const [selectedConfigOption, setSelectedConfigOption] = useState("")

  useEffect(() => {    
    console.log("Opciones de configuración cargadas correctamente.")    			

    cargarConfiguracionActualPaso()      

    initialConfigCommonJS.cargarOpcionesConfiguracionInstalacion()      
            
  }, []);

  function cargarConfiguracionActualPaso(){

    var lastAuthUser = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74.LastAuthUser")
    var lastAuthUserIdToken = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74."+lastAuthUser+".idToken")    
    var ongoingInstallationConfigurationID = localStorage.getItem("installationId")    
  
    //Petición de datos para el paso actual
    var jsonPeticion = {
      "accountID": localStorage.getItem("accountID"),
      "installationID": ongoingInstallationConfigurationID,
      "GeneralInfo": "",      
      "FV": "",
      "Battery": "",
      "Generator": "",
      "Cars": ""
    }
  
    // Guardo la información  
    var xhttp = new XMLHttpRequest();  
      xhttp.open("POST", getInstallationConfiguration, true);        
      xhttp.setRequestHeader('Content-Type', "application/json");
      xhttp.setRequestHeader('Authorization', lastAuthUserIdToken);
      var data = JSON.stringify(jsonPeticion);
      xhttp.onreadystatechange = function() {
        
        if (this.readyState === 4 && this.status === 200) {
          var jsonRespuesta = JSON.parse(this.responseText)
          if(jsonRespuesta.statusCode === "403"){                   
            initialConfigCommonJS.mostrarMensajeInformativo("No tiene permisos para realizar la operación.","negative")
          }
          else{         

            if( (typeof(params.selectedOption) !== "undefined") && (params.selectedOption !== "") ){
              seleccionarOpcion(params.selectedOption)              
            }

            //Si no hay datos configurados entonces no hago nada
  
            console.log("Información cargada correctamente")
          }
        }
  
        if (this.readyState === 4 && this.status !== 200) {  
          initialConfigCommonJS.mostrarMensajeInformativo('Se produjo un error al cargar la configuracion.',"negative")
          initialConfigCommonJS.gestionarRespuestaPeticionErronea(this.status)       
        }
      }
      xhttp.send(data);      
  }

  function seleccionarOpcion(opcion){

    localStorage.setItem("ongoingInstallationConfiguration",localStorage.getItem("installationId"))
    localStorage.setItem("installationConfigurationMode","true")    

    document.getElementById("asideDetalleConfiguracion").className = document.getElementById("asideDetalleConfiguracion").className.replace(" hidden", "")

    document.getElementById("contenedorPrincipalOpcion").scrollTop = 0

    var componente = ""
    var tituloDetalle = ""
    var iconoDetalle = ""

    if(opcion==="GeneralInfo"){ 
      componente = <GeneralInfo/> 
      tituloDetalle  = "Configuración general"
      iconoDetalle = "analytics"
      generalCommonJS.registrarEventoAnalitica(ReactGA, 'CONFIGURACIÓN', 'CONFIG. - '+tituloDetalle, "", "")
    }
    
    else if(opcion==="Messaging"){ 
      componente = <Messaging/> 
      tituloDetalle  = "Mensajería"
      iconoDetalle = "mail"
      generalCommonJS.registrarEventoAnalitica(ReactGA, 'CONFIGURACIÓN', 'CONFIG. - '+tituloDetalle, "", "")
    }

    document.getElementById("iconoDetalleConfiguracion").innerHTML = iconoDetalle
    document.getElementById("tituloDetalleConfiguracion").innerHTML = tituloDetalle

    setSelectedConfigOption(componente)     
  }

  function mensajeConfimacionEliminarInstalacion(){
         
    var nombreInstalacion = document.getElementById("nombreInstalacionActual").innerHTML

    initialConfigCommonJS.mostrarMensajeConfirmacionBorrado("delete","BORRADO DE CUENTA", "¿Estás seguro de que quieres borrar tu cuenta "+nombreInstalacion+" ?", initialConfigCommonJS.eliminarInstalacion, initialConfigCommonJS.cerrarMensajeBorrado)          
	
  }

  function gestionarVisibilidadDetalleConfiguracion(event){     
    if ( (document.getElementById("asideDetalleConfiguracion") !== null) && !document.getElementById("asideDetalleConfiguracion").className.includes("hidden") && (event.target.id === "asideDetalleConfiguracion") ){      
      volver()
    }
  }

  function volver(){    
    document.getElementById("asideDetalleConfiguracion").className = document.getElementById("asideDetalleConfiguracion").className.replaceAll(" hidden", "") + " hidden"    
    
    if( (typeof(params.selectedOption) !== "undefined") && (params.selectedOption !== "") ){
      window.location = "/InstallationConfiguration"
    }
  }

  return (      
    
    <>
        <section id="seleccionOpcionConfiguracion" className="step wrapper config gap-08">
        
          <div className="description comment bubble" onClick={() => generalCommonJS.gestionarVisibilidadBubbleIntro("textoIntroConfiguracionInstalacion")}>        
            <h1 className="headline-03 no-helias"><span className="fill">Configuración de tu cuenta</span><button className="link"><span className="material-icon" >info</span></button></h1>
            <div id="textoIntroConfiguracionInstalacion" className=" hidden">
              <p>Desde aquí podrás modificar la configuración de tu cuenta de instalador.</p>
            </div>
          </div> 
          
          <div className="content-wrapper horizontal">

            <div id="divOpcionesConfiguracion" className="content-wrapper col-md-12 col-lg-4">  

                <ul aria-label="Configuración de esta cuenta" className="vertical gap-02">
                <li>
                    <button className="selection icon-wrapper" onClick={() => seleccionarOpcion("GeneralInfo")}>
                    <figure className="avatar size-m cyan"><span className="material-icon">analytics</span></figure>
                    <span className="label">Configuración general</span>
                    </button>
                </li>
                <li>
                    <button className="selection icon-wrapper" onClick={() => seleccionarOpcion("Messaging")}>
                    <figure className="avatar size-m cyan"><span className="material-icon">telegram</span></figure>
                    <span className="label">Mensajería</span>
                    </button>
                </li>
                </ul>
                    
            </div>

          </div>
        </section>

        <aside id="asideDetalleConfiguracion" className="modal lateral-detail rules hidden" onMouseDown={gestionarVisibilidadDetalleConfiguracion}>

          <div id="contenedorPrincipalOpcion" className="modal-content">

            <button className="link close" onClick={() => volver()}><span className="material-icon">highlight_off</span></button>
            <div className="page">

              <section id="detalleConfiguracion" className="cyan" style={{paddingLeft: "-50px"}}>

                <div id="divDetalleConfiguracion" className="content-wrapper">

                  <header className="horizontal center gap-04">                                
                    <figure id="figureDetalleConfiguracion" className="avatar size-xl">
                      <span id="iconoDetalleConfiguracion" className="material-icon">tune</span>
                    </figure>
                    <dl className="vertical fill">
                      <dd id="tituloDetalleConfiguracion" className="headline-02"></dd>
                    </dl>
                  </header>   

                  {selectedConfigOption}
                
                </div>
                
              </section>

            </div>
          
            <Loader Id="loaderDetalleInstallationConfiguration" Mensaje=""/>

          </div>

        </aside>

    </>
  )
}

export default InstallationConfigurationOptions